import { Icon } from '@iconify/react';
import styles from './Vision2028.module.css';

interface CollapseIconProps {
  isCollapsed: boolean;
}

export const CollapseIcon = ({ isCollapsed }: CollapseIconProps) => {
  return <Icon icon={isCollapsed ? 'mdi:chevron-down' : 'mdi:chevron-up'} className={styles.chevronIcon} />;
};

